import { YearPickerInput } from "@mantine/dates";
import classes from "../../input/input.module.css";
export const yearPickerInputProps = YearPickerInput.extend({
    classNames: classes,
});
